import { SermonInfo } from './upload';

export class SermonEdit {
  constructor(public id: number, public sermonInfo: SermonInfo) {}
}
